<template>
	<div class="schoolInfo">
		<div class="schoolInfo-tab flex zhong">
			<p :class="tabId == 0 ? 'on-tab' : ''" @click="selTab(0)">学校介绍</p>
			<p :class="tabId == 1 ? 'on-tab' : ''" @click="GoUrl(1, detail.CollegesUrl)">学校官网</p>
			<p :class="tabId == 2 ? 'on-tab' : ''" @click="GoUrl(2, detail.Encyclopedia)">学校百科</p>
			<p :class="tabId == 3 ? 'on-tab' : ''" @click="GoUrl(3, detail.Constitution)">招生章程</p>
			<p :class="tabId == 4 ? 'on-tab' : ''" @click="GoUrl(4)">录取分数</p>
		</div>
		<div v-if="tabId == 0">
			<article class="school-one flex">
				<div class="school-one-left" style="position: relative;">
					<img src="../../../image/asp.png" @click="goVideo" />
					<div class="school-left-img"><img :src="detail.LogoUrl" /></div>
					<p class="school-left-name">{{ detail.CollegesName }}</p>
					<p class="school-left-name">{{ detail.SpecialtySchool }}</p>
					<div class="label_txt flex wrap">
						<span v-if="detail.N985">985</span>
						<span v-if="detail.N211">211</span>
						<span v-if="detail.NDouble">双一流</span>
						<span v-if="detail.CountryImportant">国家重点</span>
						<span v-if="detail.ProvinceImportant">省重点</span>
						<span v-if="detail.Brilliant">卓越计划</span>
					</div>
				</div>
				<div class="school-one-right">
					<ul class="one-right-c01 flex wrap">
						<li>
							<img src="../../../image/xx_a.png" />
							<p>
								建校时间：
								<font color="#333">{{ detail.BuiltDate }}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/xx_b.png" />
							<p>
								类别：
								<font color="#333">{{ detail.CollegesType }}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/xx_c.png" />
							<p>
								院校类型：
								<font color="#333">{{ detail.CollegesMold }}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/xx_d.png" />
							<p>
								隶属：
								<font color="#333">{{ detail.Subjection }}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/xx_i.png" />
							<p>
								层次：
								<font color="#333">{{ detail.Educational }}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/xx_e.png" />
							<p>
								地区：
								<font color="#333">{{ detail.Area }}</font>
							</p>
						</li>
						<!-- 22.2.16 -->
						<li>
							<img src="../../../image/apa.png" />
							<p>
								属地：
								<font color="#333">{{detail.Territory}}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/apa.png" />
							<p>
								所在市：
								<font color="#333">{{detail.CityName}}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/xx_f.png" />
							<p>
								硕士点：
								<font color="#333">{{ detail.MasterPoints }}个</font>
							</p>
						</li>
						<li>
							<img src="../../../image/xx_g.png" />
							<p>
								博士点：
								<font color="#333">{{ detail.DoctorPoints }}个</font>
							</p>
						</li>
						<li>
							<img src="../../../image/apc.png" />
							<p>
								院士人数：
								<font color="#333">{{detail.Count1}}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/apc.png" />
							<p>
								学生人数：
								<font color="#333">{{detail.Count2}}</font>
							</p>
						</li>
						<li>
							<img src="../../../image/apd.png" />
							<p>
								男女比例：
								<font color="#333">{{detail.Percent1}}</font>
							</p>
						</li>
						<li style="width: 40%;">
							<img src="../../../image/ape.png" />
							<p>
								官方电话：
								<font color="#333">{{detail.Phone}}</font>
							</p>
						</li>
						<li style="width: 40%;">
							<img src="../../../image/apf.png" />
							<p>
								电子邮箱：
								<font color="#333">{{detail.Email}}</font>
							</p>
						</li>
						<li style="width: 40%;">
							<img src="../../../image/apg.png" />
							<p>
								院校特色：
								<font color="#333">{{detail.Feature}}</font>
							</p>
						</li>
					</ul>
					<div class="one-righe-txt">
						<!-- :class="isUp ? 'on-txt' : ''" -->
						<p :class="isUp ? 'on-txt' : ''">{{ detail.Introduce }}</p>
						<div class="one-up">
							<span @click="upBtn">{{ isUp ? '收起' : '全部' }}</span>
						</div>
					</div>
				</div>
			</article>
			<article class="school-two flex float">
				<!-- two-left -->
				<div class="two-left">
					<div class="two-left-c01">
						<p class="two-left-tit">院校排名</p>
						<ul class="two-rank two-rankaa">
							<li class="flexFloat">大学排名 <span style="color:#ff0000">#{{ detail.Rank1 }}</span></li>
							<li class="flexFloat">校友会排名<span style="color:#ff0000">#{{ detail.Rank2 }}</span></li>
							<li class="flexFloat">武书连排名<span style="color:#ff0000">#{{ detail.Rank3 }}</span></li>
							<li class="flexFloat">软科排名<span style="color:#ff0000">#{{ detail.Rank4 }}</span></li>
						</ul>
					</div>
					<div class="two-left-c01">
						<p class="two-left-tit">特色专业</p>
						<!--   -->
						<div class="major-tab on">
							{{ detail.SpecialProfession }}
							<!-- <p @click="isAopen = !isAopen">{{ isAopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<div class="two-left-c01">
						<p class="two-left-tit">历史文化</p>
						<!--   -->
						<div class="major-tab on">
							{{ detail.History }}
							<!-- <p @click="isAopen = !isAopen">{{ isAopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<!-- 、22.2.15 -->
					<!-- <div class="two-left-c01">
                        <p class="two-left-tit">分数线</p>
                        <div class="two-left-tab">
                            <div class="two-tab-tit">历年数据</div>
                            <div class="years-tab">
                                <div class="years-tab-tr">
                                    <p>年份</p>
                                    <p>考生类型</p>
                                    <p>录取批次</p>
                                    <p>平均分</p>
                                    <p>最低分</p>
                                    <p>最低位次</p>
                                </div>
                                <ul class="years-td">
                                    <li v-for="(item, index) in detail.ScoreList" :key="index">
                                        <p>{{ item.Year }}</p>
                                        <p>{{ item.CandidatesType }}</p>
                                        <p>{{ item.AdmissionBatch }}</p>
                                        <p>{{ item.Average }}</p>
                                        <p>{{ item.LowestScore }}</p>
                                        <p>{{ item.LowestOrder }}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="two-left-c01">
                        <p class="two-left-tit">学院</p>
                        <div class="major-tab">{{ detail.College }}</div>
                    </div>-->
					<div class="two-left-c01">
						<p class="two-left-tit">开设学院</p>
						<!-- :class="!isBopen ? 'on' : ''" -->
						<div class="major-tab on">
							{{detail.OpenAcademy}}
							<!-- <p @click="isBopen = !isBopen">{{ isBopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<div class="two-left-c01">
						<p class="two-left-tit">双一流学科</p>
						<!-- :class="!isCopen ? 'on' : ''" -->
						<div class="major-tab on">
							{{detail.DoubleSubject}}
							<!-- <p @click="isCopen = !isCopen">{{ isCopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<div class="two-left-c01">
						<p class="two-left-tit">硕士点</p>
						<!-- :class="!isDopen ? 'on' : ''" -->
						<div class="major-tab on">
							{{detail.MasterPoints2}}
							<!-- <p @click="isDopen = !isDopen">{{ isDopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<div class="two-left-c01">
						<!-- :class="!isEopen ? 'on' : ''" -->
						<p class="two-left-tit">博士点</p>
						<div class="major-tab on">
							{{detail.DoctorSubjects2}}
							<!-- <p @click="isEopen = !isEopen">{{ isEopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<div class="two-left-c01">
						<p class="two-left-tit">第四轮学科评估结果</p>
						<!--  :class="!isFopen ? 'on' : ''" -->
						<div class="major-tab on">
							{{detail.Result1}}
							<!-- <p @click="isFopen = !isFopen">{{ isFopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<div class="two-left-c01">
						<p class="two-left-tit">师资力量</p>
						<!-- :class="!isGopen ? 'on' : ''" -->
						<div class="major-tab on">
							{{detail.TeacherPower}}
							<!-- <p @click="isGopen = !isGopen">{{ isGopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<div class="two-left-c01">
						<p class="two-left-tit">知名校友</p>
						<!-- :class="!isHopen ? 'on' : ''" -->
						<div class="major-tab on">
							{{detail.Famous}}
							<!-- <p @click="isHopen = !isHopen">{{ isHopen ? '...全部' : '收起' }}</p> -->
						</div>
					</div>
					<!-- <div class="two-left-c01">
						<p class="two-left-tit">就业走向</p>
						<div class="major-tab on"><img :src="detail.EmployDirectionUrl" /></div>
					</div> -->
				</div>
			</article>
		</div>
		<div v-if="tabId == 4" class="fen_box">
			<div class="fen_view">
				<ul>
					<li>
						<p class="two-left-tit">院校分数</p>
						<div class="tian_biao">
							<p>历年数据</p>
							<div class="tian_head biao_two flex">
								<div class="tian_one">年份</div>
								<div class="tian_one">考生类型</div>
								<div class="tian_one">录取批次</div>
								<div class="tian_one">专业组</div>
								<div class="tian_one">最低分</div>
								<div class="tian_one">最低位次</div>
								<div class="tian_one">备注</div>
							</div>
							<div class="ptgaodu">
								<div class="tian_head biao_two biao_two_color biao_one_bg flex zhong"
									v-for="(item, index) in oneList" :key="index">
									<div class="tian_one">{{item.Year}}</div>
									<div class="tian_one">{{item.CandidatesType}}</div>
									<div class="tian_one">{{item.AdmissionBatch}}</div>
									<div class="tian_one">{{item.Average}}</div>
									<div class="tian_one">{{item.LowestScore}}</div>
									<div class="tian_one">{{item.LowestOrder}}</div>
									<div class="tian_one">{{item.Remarks}}</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<p class="two-left-tit">专业分数</p>
						<div class="flex zhong fen_dan">
							<div class="dan_kuan">
								<el-select v-model="timeValue" placeholder="年份" @change="changeValueOne">
									<el-option v-for="item in timeOptions" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</div>
							<div class="dan_kuan">
								<el-select v-model="avalue" placeholder="文科或选历史" @change="changeValueOne">
									<el-option v-for="item in aoptions" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</div>
							<div class="dan_kuan">
								<el-select v-model="bvalue" placeholder="本科批" @change="changeValueOne">
									<el-option v-for="item in boptions" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="tian_biao">
							<div class="tian_head biao_two flex">
								<div class="tian_one">专业名称</div>
								<div class="tian_one">年份</div>
								<div class="tian_one">考试类型</div>
								<div class="tian_one">录取批次</div>
								<div class="tian_one">专业组</div>
								<div class="tian_one">最低分</div>
								<div class="tian_one">最低位次</div>
							</div>
							<div class="ptgaodu">
								<div class="tian_head biao_two biao_two_color biao_one_bg flex zhong"
									v-for="(item, index) in twoList" :key="index">
									<div class="tian_one flexCenter" >
										<p class="shl">{{item.MajorName}}</p>
										<i :title="item.MajorName"></i>
									</div>
									<div class="tian_one">{{item.Year}}</div>
									<div class="tian_one">{{item.CandidatesType}}</div>
									<div class="tian_one">{{item.AdmissionBatch}}</div>
									<div class="tian_one">{{item.Average}}</div>
									<div class="tian_one">{{item.LowestScore}}</div>
									<div class="tian_one">{{item.LowestOrder}}</div>
								</div>
							</div>
						</div>
					</li>

					<li>
						<p class="two-left-tit">招生计划</p>
						<div class="flex zhong fen_dan">
							<el-select v-model="timeValue2" placeholder="年份" @change="changeValue" style="    margin-right: 20px;">
								<el-option v-for="item in timeOptions2" :key="item" :label="item" :value="item">
								</el-option>
							</el-select>
							<div class="dan_kuan">
								<el-select v-model="cvalue" placeholder="文科或选历史" @change="changeValue">
									<el-option v-for="item in coptions" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</div>
							<div class="dan_kuan">
								<el-select v-model="dvalue" placeholder="本科批" @change="changeValue">
									<el-option v-for="item in doptions" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="tian_biao">
							<div class="tian_head biao_two flex">
								<div class="tian_one flexCenter" ><p style="width: 146px;">专业名称</p></div>
								<div class="tian_one">专业代码</div>
								<div class="tian_one">专业组</div>
								<div class="tian_one">院校代码</div>
								<div class="tian_one">计划数</div>
								<div class="tian_one">录取批次</div>
								<div class="tian_one">首选科目</div>
								<div class="tian_one">选科科目</div>
								<div class="tian_one">学制</div>
								<div class="tian_one">学费</div>
							</div>
							<div class="ptgaodu">
								<div class="tian_head biao_two biao_two_color biao_one_bg flex zhong"
									v-for="(item, index) in threeList" :key="index">
									<div class="tian_one flexCenter" style="width: 147px;">
										<p class="shl" style="width: 110px;">{{item.MajorName}}</p>
										<i :title="item.MajorName"></i>
									</div>
									<div class="tian_one">{{item.MajorCode}}</div>
									<div class="tian_one">{{item.GroupName}}</div>
									<div class="tian_one">{{item.CollegesCode}}</div>
									<div class="tian_one">{{item.Plan}}</div>
									<div class="tian_one">{{item.AdmissionBatch}}</div>
									<div class="tian_one">{{item.PreferredSubject}}</div>
									<div class="tian_one">{{item.RequirementsSubjects}}</div>
									<div class="tian_one">{{item.Educational}}</div>
									<div class="tian_one">{{item.Tuition}}</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<p class="two-left-tit">选科要求</p>
						<div class="tian_biao">
							<div class="tian_head biao_two biao_three flex">
								<div class="tian_one">专业名称</div>
								<div class="tian_one">备注</div>
								<div class="tian_one">首选科目</div>
								<div class="tian_one">选科科目</div>
							</div>
							<div class="ptgaodu">
								<div class="tian_head biao_two biao_three biao_two_color biao_one_bg flex zhong aavbiao"
									v-for="(item, index) in fourList" :key="index">
									<div class="tian_one">{{item.MajorName}}</div>
									<div class="tian_one">{{item.Remarks}}</div>
									<div class="tian_one">{{item.PreferredSubject}}</div>
									<div class="tian_one">{{item.RequirementsSubjects}}</div>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<!--视频 -->
		<div class="popup flexCenter" v-if="isVideo">
			<div class="video">
				<img src="../../../image/vol-del-t.png" @click="isVideo = false" />
				<video :src="detail.VideoUrl" autoplay controls></video>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				tabId: 0,
				// 展开收起
				isUp: false,
				aoptions: [],
				boptions: [],
				coptions: [],
				doptions: [],
				// 分数线
				lineList: [{
						years: '2020',
						even: '606',
						minScore: '500',
						minSeat: '985'
					},
					{
						years: '2019',
						even: '606',
						minScore: '500',
						minSeat: '985'
					},
					{
						years: '2018',
						even: '606',
						minScore: '500',
						minSeat: '985'
					},
					{
						years: '2017',
						even: '606',
						minScore: '500',
						minSeat: '985'
					}
				],
				// 专业
				majorList: [{
						name: '统计学院',
						mjList: [{
								txt: '经济统计学(金融统计与精算)(本)'
							},
							{
								txt: '经济统计学(金融统计与精算)(本)'
							},
							{
								txt: '经济统计学(金融统计与精算)(本)'
							}
						]
					},
					{
						name: '商学院',
						mjList: [{
								txt: '物流管理(本)'
							},
							{
								txt: '人力资源管理(本)'
							}
						]
					}
				],
				schoolName: '',
				detail: {},
				// 22.2.15
				isVideo: false,
				// 专业分数
				avalue: '',
				aFvalue: '',
				// 招生计划
				bvalue: '',
				cvalue: '',
				dvalue: '',
				timeValue: '',
				timeValue2: '',
				isAopen: true,
				isBopen: true,
				isCopen: true,
				isDopen: true,
				isEopen: true,
				isFopen: true,
				isGopen: true,
				isHopen: true,
				oneList: [],
				timeOptions1: [],
				timeOptions2: [],
				twoList: [],
				threeList: [],
				fourList: []
			};
		},
		mounted: function() {
			var that = this;
			console.log('页面传参', that.$route.query);
			that.schoolName = that.$route.query.schoolname ? that.$route.query.schoolname : '';
			that.GetDetail();
			that.RecentlyAdmissionScore();
			that.RecentlySectionRequirements();
		},
		methods: {
			changeValueOne() {
				this.RecentlyProfessionaScore();
			},
			changeValue() {
				this.RecentlyEnrollmentPlan();
			},
			// 展开收起
			upBtn() {
				this.isUp = !this.isUp;
			},
			// 切换
			selTab(id) {
				this.tabId = id;
			},
			goVideo() {
				if (!this.detail.VideoUrl) {
					this.$util.showMsg(false, '请上传院校视频');
					return;
				}
				window.open(this.detail.VideoUrl);
			},
			// 跳转外部
			GoUrl: function(index, url) {
				this.tabId = index;
				if (this.tabId === 1 || this.tabId === 2 || this.tabId === 3) {
					window.open(url);
				}
			},
			// 获取院校详情
			GetDetail: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetCollegeIntroductionDetail?name=' + that.schoolName,
					'GET', {},
					function(res) {
						console.log('获取院校详情');
						console.log(res);
						if (res.code === 0) {
							that.detail = res.data;
							that.timeOptions = res.condition.list1;
							that.timeValue = that.timeOptions[0];
							that.aoptions = res.condition.list2;
							that.avalue = that.aoptions[0];
							that.boptions = res.condition.list3;
							that.bvalue = that.boptions[0];
							that.timeOptions2 = res.condition.list4;
							that.timeValue2 = that.timeOptions2[0];
							that.coptions = res.condition.list5;
							that.cvalue = that.coptions[0];
							that.doptions = res.condition.list6;
							that.dvalue = that.doptions[0];
							that.$nextTick(() => {
								that.RecentlyProfessionaScore();
								that.RecentlyEnrollmentPlan();
							});
						}
					},
					function(res) {
						setTimeout(() => {
							self.opener = null;
							self.close();
						}, 1500);
					}
				);
			},
			RecentlyAdmissionScore() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/RecentlyAdmissionScore?collegeName=' + that.schoolName,
					'GET', {},
					function(res) {
						console.log('获取院校分数');
						console.log(res);
						if (res.code === 0) {
							that.oneList = res.data;
						}
					},
					function(err) {
						console.log(err);
					});
			},
			RecentlyProfessionaScore() {
				var that = this;
				console.log('that.timeValue2', that.timeValue);
				console.log('that.cvalue', that.avalue);
				console.log('that.dvalue', that.bvalue);
				that.$api.HtppRequest(
					'WebsiteSet/RecentlyProfessionaScore?collegeName=' + that.schoolName + '&Year=' + that
					.timeValue + '&CandidatesType=' + that.avalue + '&AdmissionBatch=' + that.bvalue,
					'GET', {},
					function(res) {
						console.log('获取专业分数');
						console.log(res);
						if (res.code === 0) {
							that.twoList = res.data;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			RecentlyEnrollmentPlan() {
				var that = this;
				console.log('that.timeValue2', that.timeValue2);
				console.log('that.cvalue', that.cvalue);
				console.log('that.dvalue', that.dvalue);
				that.$api.HtppRequest(
					'WebsiteSet/RecentlyEnrollmentPlan?collegeName=' + that.schoolName + '&Year=' + that
					.timeValue2 + '&CandidatesType=' + that.cvalue + '&AdmissionBatch=' + that.dvalue,
					'GET', {},
					function(res) {
						console.log('获取专业分数');
						console.log(res);
						if (res.code === 0) {
							that.threeList = res.data;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			RecentlySectionRequirements() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/RecentlySectionRequirements?collegeName=' + that.schoolName,
					'GET', {},
					function(res) {
						console.log('获取院校分数');
						console.log(res);
						if (res.code === 0) {
							that.fourList = res.data;
						}
					},
					function(err) {
						console.log(err);
					});
			}
		}
	};
</script>

<style scoped>
	.video img {
		display: block;
		width: 22px;
		height: 22px;
		position: absolute;
		right: 20px;
		top: 10px;
		cursor: pointer;
	}

	.video video {
		width: 100%;
		display: block;
		height: 100%;
		object-fit: cover;
	}

	.video {
		width: 800px;
		height: 470px;
		position: relative;
		padding: 40px 20px 20px 20px;
		background-color: #fff;
		border-radius: 6px;
	}

	.school-one-left>img {
		display: block;
		width: 33px;
		height: 25px;
		position: absolute;
		right: 16px;
		top: 120px;
		margin: 0;
		z-index: 1;
		cursor: pointer;
	}

	.label_txt span {
		display: inline-block;
		margin-top: 6px;
		margin-left: 10px;
		min-width: 35px;
		padding: 0 10px;
		background-color: #ffefda;
		border-radius: 4px;
		color: #f59a23;
		text-align: center;
		line-height: 26px;
		font-size: 14px;
	}

	.major-tab img {
		display: block;
		max-width: 100%;
	}

	.major-tab p,
	.two-special p {
		color: #005270;
		background-color: #fff;
		position: absolute;
		right: 0;
		bottom: 0;
		z-index: 1;
		cursor: pointer;
	}

	.major-tab,
	.two-special {
		width: fit-content !important;
		position: relative;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
		word-wrap: break-word;
		white-space: pre-line;
	}

	.major-tab.on {
		overflow: auto;
		display: block;
	}

	.major-tab.on p {
		position: static;
	}

	.tian_one {
		border-right: solid 1px #eeeeee;
	}

	.biao_three .tian_one {
		width: 25% !important;
	}

	.tian_one:last-child {
		border-right: none;
	}

	/deep/.el-date-editor {
		width: 100% !important;
	}

	.dan_kuan {
		width: 150px;
		margin-right: 20px;
	}

	.biao_two .tian_one {
		width:calc( 100% / 7 );
		min-height: 60px;
	}

	.fen_dan {
		padding-bottom: 20px;
	}

	.tian_one>p {
		line-height: initial;
		max-width: 70%;
		text-align: center;
	}

	.tian_one i {
		width: 24px;
		height: 16px;
		display: inline-block;
		background: url(../../../image/qc.png) no-repeat left top;
		background-size: 100% 100%;
		cursor: pointer;
		margin-left: 12px;
	}

	.fen_view li:first {
		padding-top: 0px;
	}

	.fen_view li {
		padding-top: 5px;
	}

	.tian_biao>p {
		line-height: 36px;
		text-align: center;
		background-color: #dadada;
		color: #000;
		font-size: 14px;
		border: solid 1px #eeeeee;
	}

	.two_btn p::after {
		content: '';
		width: 100%;
		height: 1px;
		position: absolute;
		left: 0;
		bottom: 17px;
		margin-bottom: 0;
		z-index: 1;
		background-color: #a6a6a6;
	}

	.two_btn p {
		color: #000000;
		margin: 0 20px;
		position: relative;
		cursor: pointer;
	}

	.biao_two_color .tian_one {
		font-size: 14px;
		color: #666666;
	}

	.aavbiao .tian_one {
		height: 60px;
		display: flex;
		justify-content: center;
		line-height: normal;
		align-items: center;
	}

	.biao_two .tian_one:last-child {
		border-right: none;
	}

	.biao_one_bg {
		background-color: transparent !important;
	}

	.tian_one button {
		font-size: 14px;
		color: #005371;
		width: 80px;
		height: 30px;
		border-radius: 4px;
		line-height: 30px;
		text-align: center;
		border: solid 1px #005371;
		cursor: pointer;
	}

	.biao_one .tian_one:nth-child(2) {
		width: 450px;
		box-sizing: border-box;
		border-left: solid 1px #eeeeee;
		border-right: solid 1px #eeeeee;
	}

	.tian_one {
		font-size: 16px;
		color: #333333;
		text-align: center;
	}

	.tian_head {
		height: 60px;
		line-height: 60px;
		background-color: #f5f5f5;
		border-bottom: solid 1px #eeeeee;
	}

	.tian_head:last-child {
		border-bottom: none;
	}

	.tian_biao {
		border: solid 1px #eeeeee;
		margin-top: 18px;
	}

	/* 01 */

	.fen_box li {
		margin-top: 10px;
	}

	.fen_box li:first-child {
		margin-top: 0px;
	}

	.fen_view {
		padding: 0 20px 20px 20px;
		border: solid 1px #dddddd;
	}

	.fen_box {
		padding: 0 20px 20px 20px;
	}

	.schoolInfo {
		width: 1200px;
		margin: 30px auto;
		height: auto;
		background-color: #fff;
		padding: 30px 0;
	}

	/* schoolInfo-tab */
	.schoolInfo-tab {
		width: 100%;
		padding: 0 20px;
		margin-bottom: 20px;
	}

	.schoolInfo-tab p {
		width: 180px;
		height: 40px;
		line-height: 38px;
		text-align: center;
		font-size: 14px;
		color: #333;
		font-weight: bold;
		border-radius: 5px 5px 0 0;
		border: 1px solid #dddddd;
		cursor: pointer;
	}

	.schoolInfo-tab .on-tab {
		background-color: #444444;
		border: 1px solid #444444;
		color: #fff;
	}

	/* school-one */
	.school-one {
		width: calc(100% - 40px);
		margin: 0 auto 20px auto;
		height: auto;
		background-color: #f5f5f5;
	}

	/* school-one-left */
	.school-one-left {
		background-color: #ececec;
		width: 200px;
		height: auto;
		padding-bottom: 40px;
	}

	.school-left-img {
		width: 100px;
		height: 100px;
		margin: 45px auto 30px auto;
		background: url(../../../image/p-head.png) no-repeat;
		background-size: 100% 100%;
		border-radius: 50%;
	}

	.school-left-img img {
		width: 100%;
		height: 100%;
		display: block;
		border-radius: 50%;
	}

	.school-left-name {
		width: 100%;
		font-size: 16px;
		color: #333;
		text-align: center;
	}

	/* school-one-right */
	.school-one-right {
		flex: 1;
		height: auto;
	}

	/* one-right-c01 */
	.one-right-c01 {
		width: 100%;
		height: auto;
		margin-top: 20px;
		padding: 0 20px;
	}

	.one-right-c01 li {
		width: 20%;
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.one-right-c01 li>img {
		width: 30px;
		height: 30px;
		display: block;
	}

	.one-right-c01 li>p {
		font-size: 14px;
		color: #666;
	}

	.one-righe-txt {
		width: 100%;
		height: auto;
		padding: 0 20px;
	}

	.one-righe-txt p {
		font-size: 14px;
		color: #666;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		overflow: hidden;
	}

	.one-righe-txt .on-txt {
		display: block;
	}

	.one-up {
		display: flex;
		justify-content: flex-end;
		margin: 15px 0;
	}

	.one-up span {
		font-size: 14px;
		color: #000;
		cursor: pointer;
	}

	/* school-two */
	.school-two {
		width: 100%;
		height: auto;
		padding: 0 20px;
	}

	.two-left {
		width: 100%;
		height: auto;
		border: 1px solid #ddd;
		padding-bottom: 30px;
	}

	.two-left-c01 {
		width: 100%;
		padding: 0 20px;
		height: auto;
	}

	.two-left-tit {
		font-size: 16px;
		color: #333;
		position: relative;
		padding-left: 17px;
		margin: 20px 0;
	}

	.two-left-tit::after {
		width: 0;
		height: 18px;
		border: 2px solid #111111;
		border-radius: 50px;
		position: absolute;
		content: '';
		left: 0;
		top: 50%;
		margin-top: -10px;
	}

	/* two-left-tab */
	.two-left-tab {
		width: 100%;
		height: auto;
		border: 1px solid #eee;
	}

	.two-tab-tit {
		width: 100%;
		height: 35px;
		line-height: 35px;
		text-align: center;
		font-size: 14px;
		background-color: #dadada;
	}

	.years-tab {
		width: 100%;
		height: auto;
	}

	.years-tab-tr {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		background-color: #f5f5f5;
	}

	.years-tab-tr p {
		width: 25%;
		font-size: 14px;
		color: #333;
		text-align: center;
		border-right: 1px solid #dadada;
		height: 60px;
		line-height: 60px;
	}

	.years-tab-tr p:last-child {
		border-right: none;
	}

	.years-td {
		width: 100%;
		height: auto;
	}

	.years-td li {
		border-bottom: 1px solid #dadada;
		display: flex;
		align-items: center;
	}

	.years-td li:last-child {
		border-bottom: none;
	}

	.years-td li p {
		width: 25%;
		font-size: 14px;
		color: #666;
		text-align: center;
		border-right: 1px solid #dadada;
		height: 50px;
		line-height: 50px;
	}

	.years-td li p:last-child {
		border-right: none;
	}

	/* major-tab */
	.major-tab {
		width: 100%;
		height: auto;
		font-size: 14px;
		color: #333;
	}

	/* two-right */
	.two-right {
		width: 500px;
		height: auto;
		border: 1px solid #ddd;
	}

	/* two-rank */
	.two-rank {
		width: 100%;
		padding: 0 30px;
		height: auto;
	}

	.two-rank li {
		width: 100%;
		padding: 20px 15px;
		height: auto;
		font-size: 16px;
		color: #fa483d;
		background-color: #feeceb;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.two-special {
		font-size: 14px;
		color: #333;
	}

	.two-rankaa li {
		color: #000;
	}

	.ptgaodu {
		max-height: 500px;
		overflow: auto;
	}

	.ptgaodu::-webkit-scrollbar {
		width: 0px;
	}
</style>
<style>
	.pp-header {
		z-index: 2000 !important;
	}
</style>
